// extracted by mini-css-extract-plugin
export default {"listItem":"DataRequestsMenuListItem_listItem__rCBU1","selected":"DataRequestsMenuListItem_selected__k9xCA","extraWidth":"DataRequestsMenuListItem_extraWidth__+lk9S"};